@if (!isModoPadrao) {
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">description</mat-icon>
        <span>Modelos de documento</span>
    </div>
    <p class="section-hint">Selecione os modelos de documento aos quais esta regra tributária se aplica.</p>

    <div class="action-card-grid modelos-grid" role="group" aria-label="Modelos de documento">
        @for (modelo of modelos; track modelo.codigo) {
        <button
            type="button"
            class="action-card-action"
            role="checkbox"
            [attr.aria-checked]="isSelecionado(modelo.codigo)"
            (click)="toggle(modelo.codigo)">
            <app-action-card
                [title]="modelo.nome + ' - ' + modelo.descricao"
                icon="description"
                [interactive]="true"
                [selected]="isSelecionado(modelo.codigo)">
                <mat-icon cardActions class="material-symbols-outlined" aria-hidden="true">
                    {{ isSelecionado(modelo.codigo) ? 'check_circle' : 'circle' }}
                </mat-icon>
            </app-action-card>
        </button>
        }
    </div>
</div>
}
